<template>
  <div class="bg">
    <headline :params="headLines"></headline>
    <div class="container">
      <div class="content">
        <article>
          <ul>
            <li class="must title">
              <input type="text" v-model="global.report_title" placeholder="输入标题" maxlength="60">
              <span>{{`${(global.report_title || '').length}/60`}}</span>
            </li>
            <li class="must">
              <div class="between">
                <div>
                  <label>发布部门</label>
                  <div :class="{'select-box': true, disableSelect: !global.depart_change}" v-if="global.depart_arr">
                    <span @click.stop="selectUp('depart', '', global.depart_change)" :class="{down:select.depart.on,notEmpty:select.depart.text}">{{select.depart.text || "请选择部门"}}</span>
                    <dl v-if="select.depart.on==true">
            <li v-for="(item,index) in global.depart_arr" :key="index" @click="selectUp('depart',item, global.depart_change)" :class="{active:select.depart.id==item.id, lastItem: true}">{{item.title}}
            </li>
            </dl>
      </div>
    </div>
    <!-- <div>
                <label>发送平台</label>
                <div class="select-box">
                  <span @click.stop="openPlat()" :class="{down:select.platform.on,notEmpty:pushList.filter(i => i.selected).length>0}">{{pushList.filter(i => i.selected).map(j => j.title).join(',') || "请选择平台"}}</span>
                  <dl v-if="select.platform.on==true">
                    <li v-for="(item,index) in pushList" :key="index" @click.stop="selectPlatform(item, pushList)" :class="{active: item.selected, lastItem: true}">{{item.title}}</li>
                  </dl>
                </div>
              </div> -->
  </div>
  </li>
  <!-- <li class="must">
          <label>文稿类型</label>
          <p :class="{btn:true, active: item.id === selectedType.id}" v-for="(item, index) in global.type_list" :key="index" @click="draftType(item)">{{item.title}}</p>
        </li> -->
  <!-- <p v-show="selectedType.id == 1" class="warn">警告：红色模版请勿删除！</p> -->
  <div :style="{width: errors.width, top: `${errors.scrollTop}px`}" :class="{errorWrapper: true, fixError: errors.fix}">
    <div :class="{errors: true}" v-show="errors.list.length > 0">
      <img src="@assets/img/common/close-red.svg" alt="close" class="closeError" @click="errors.list = []">
      <p class="head">
        <span class="left">
          <img src="@assets/img/common/warnRed.svg" alt="warn">
          <span class="title">检测到错别字</span>
          <span>（点击文字自动跳转）</span>
        </span>
        <span v-if="errors.showToggle" class="right" @click="errors.dexpand = !errors.dexpand">
          <span>{{errors.dexpand ? '展开' : '收起'}}</span>
          <img :src="errors.dexpand ? icons.downRed : icons.upRed" alt="icon">
        </span>
      </p>
      <div :class="{points: true, dexpand: errors.dexpand}">
        <p @click="locateWord(p)" class="point" v-for="(p, i) in errors.list" :key="i">
          {{p.Error}}
        </p>
      </div>
    </div>
  </div>
  <div class="ueditor tvWrapper radioWrapper" v-show="selectedType.id == 2">
    <p ref="radioTextBody" class="myeditor bodyPart" contenteditable @input="asyncText('body', 'radio', $event)"></p>
  </div>
  <div class="ueditor tvWrapper" v-show="selectedType.id == 1" id="tvWrapper">
    <!-- <vue-ueditor-wrap mode="observer" @ready="tvReady" v-model="tvContent" :config="tvConfig"></vue-ueditor-wrap> -->
    <p class="tvBlock">[正文]</p>
    <p ref="tvTextBody" class="myeditor bodyPart" contenteditable @input="asyncText('body', 'tv', $event)"></p>
    <p class="tvBlock">[导语]</p>
    <p ref="tvTextLead" class="myeditor" contenteditable @input="asyncText('lead', 'tv', $event)"></p>
    <p class="tvBlock">[编后]</p>
    <p ref="tvTextAfter" class="myeditor" contenteditable @input="asyncText('after', 'tv', $event)"></p>
  </div>
  <div class="normalWrapper _hiddenNormal" v-html="normalContent"></div>
  <div class="ueditor normalWrapper" v-show="selectedType.id == 0" id="normalWrapper">
    <vue-ueditor-wrap @ready="normalReady" v-model="normalContent" :config="normalConfig"></vue-ueditor-wrap>
    <div class="loadingWithContent-wrapper" v-show="transformingImgs.loading">
      <div class="loadingWithContent">
        <img src="@assets/img/common/loading.svg" alt="loading" />
        <div class="title">
          {{ transformingImgs.msg }}
        </div>
      </div>
    </div>
  </div>
  <li class="bt check">
    <button v-if="global.has_check_content_role" @click="checkWords()">错别字检查</button>
    <div>
      <!-- <span v-if="selectedType.id == 2">{{`正文：${radioText.length}字 ${Math.ceil(bodyDurantion)}秒`}}</span> -->
      <span v-if="selectedType.id == 1">{{`正文：${bodyText.length}字 ${Math.ceil(bodyDurantion)}秒`}}</span>
      <span v-if="selectedType.id == 1">/</span>
      <span v-if="selectedType.id == 1">{{`导语：${headText.length}字 ${Math.ceil(headDurantion)}秒`}}</span>
      <span v-if="selectedType.id == 1">/</span>
      <span v-if="selectedType.id == 1">语速：
        <input type="number" v-model="speed" @blur="setSpeed()">字/分钟
      </span>
    </div>
    <button v-if="global.has_makeup_audio_role" class="end" @click="compositeAudio()">文稿合成音频</button>
  </li>
  <li class="bt multi">
    <div class="left-container">
      <div v-show="cover" class="cover" :style="'background-image: url('+cover+')'"></div>
      <img src="@assets/img/common/add-green.svg" alt="">
      <p>添加封面</p>
      <div class="btn" v-if="!hasCover">
        <span @click="localUpload">本地上传</span>
        <p class="line"></p>
        <span @click="maskMaterial">我的素材</span>
      </div>
      <div class="btn" v-if="hasCover" @click.stop="hasCover = false">
        <span>更换封面</span>
      </div>
    </div>
    <div class="right-container">
      <div class="sec">
        <div class="title">记者</div>
        <input type="text" placeholder="多名记者请以空格分割" v-model="global.reporters">
        <p class="line"></p>
      </div>
      <div class="sec">
        <div class="title">摄像</div>
        <input type="text" placeholder="多名摄像请以空格分割" v-model="global.cameras">
      </div>
    </div>
    <!-- <div class="half">
      <div class="title">记者</div>
      <input type="text" placeholder="多名记者请以空格分割" v-model="global.reporters">
    </div>
    <div class="half">
      <div class="title">摄像</div>
      <input type="text" placeholder="多名摄像请以空格分割" v-model="global.cameras">
    </div> -->
  </li>
  <li class="bt mt" v-if="!!global.topicExist">
    <button class="re" @click="openWith('withTopic')">{{`关联${$_syscfg.topic}`}}</button>
    <span :class="{with: !!withTopic.id}">
      <span>{{withTopic.title || `仅可关联1条${$_syscfg.topic}`}}</span>
      <img v-if="!!withTopic.id" src="@assets/img/common/del.svg" alt="del" @click="deleteTpc(withTopic)">
    </span>
  </li>
  <li class="bt" v-if="!!global.interviewExist">
    <button class="re" @click="openWith('withInterview')">{{`关联${$_syscfg.interview}`}}</button>
    <span :class="{with: !!withInterview.id}">
      <span>
        {{withInterview.title || `仅可关联1条${$_syscfg.interview}`}}
      </span>
      <img v-if="!!withInterview.id" src="@assets/img/common/del.svg" alt="del" @click="deleteItv(withInterview)">
    </span>
  </li>
  <div class="tagli">
    <div class="gbtn" @click="generateTag()">
      一键生成标签
    </div>
    <li class="bt flx1 noBorder">
      <!-- <button class="tag" v-for="(t, i) in global.tags" :key="i">
              <span>{{t}}</span>
              <img src="@assets/img/common/del.svg" alt="del" @click="deleteTag(t)">
            </button> -->
      <span>
        <input type="text" placeholder="请输入自定义标签，回车添加" v-model="tag" @keyup.enter="addTag">
      </span>
    </li>
  </div>
  <div class="tagli">
    <div class="tag" v-for="(t, i) in global.tags" :key="i">
      <span>{{t}}</span>
      <img src="@assets/img/common/del.svg" alt="del" @click="deleteTag(t)">
    </div>
  </div>
  </ul>
  </article>
  <aside class="_xnsAside">
    <mediaCenter ref="mediaCenter" @deleteMedia="deleteMedia" :select="select" :pageType="1" v-on:getPid="getPid" :data="mediaData" v-on:getInsert="getInsert" v-on:getFold="getFold"
      v-on:getUploading="getUploading" :canComposite="global.has_pickup_text_role" :canInsert="canInsert" v-on:getComplete="uploadComplete" v-on:getConfig="getUploadConfig" @setNewCover="setNewCover"
      :canShowEdit="global.has_edit_audio_role" :canShowPicEdit="global.has_edit_img_role" />
    <div :class="{'aside-content mt': true, 'folded': !showClue}" v-if="!!global.materialExist">
      <p class="ptitle">
        <span>{{`关联${$_syscfg.clue}`}}</span>
        <span class="right">
          <span class="withBtn" @click="addClue()">
            <img src="@assets/img/common/add-green.svg" alt="add">
            <span>{{`添加${$_syscfg.clue}`}}</span>
          </span>
          <span>
            <span class="num" @click="foldClues()">
              {{(global.materials || []).length}}
              <img :src="showClue ? icons.upward: icons.downward" alt="icon">
            </span>
          </span>
        </span>
      </p>
      <div class="nav-content" v-show="showClue">
        <empty :msg="`暂无${$_syscfg.clue}`" v-if="global.materials && global.materials.length === 0" />
        <div class="itemContainer" v-for="(img, index) in global.materials" :key="index">
          <div class="clueItem">
            <div class="headline">
              <div class="cover">
                <img :src="img.material_img || img.cover || defaultImg" alt="cover">
              </div>
              <p class="title">
                <span @click="goClue(img.material_id)">{{img.material_title || img.title}}</span>
                <img src="@assets/img/common/rm.svg" alt="del" @click="deleteClue(img)">
              </p>
            </div>
            <p class="detail">
              {{img.material_content || img.content}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </aside>
  </div>
  <footer>
    <li class="button left">
      <button :class="{'disabled': uploading}" @click="saveAndJump('save')" v-if="global.has_draft">保存草稿</button>
      <button :class="{'disabled': uploading}" @click="saveAndJump('modify')" v-if="global.has_modify">修改</button>
      <button :class="{'disabled': uploading}" @click="saveAndApprove()" v-if="global.has_modify">修改并通过</button>
      <button :class="{'disabled': uploading}" @click="releaseAndJump('save')" v-if="select.depart.has_release">提交</button>
      <button :class="{'disabled': uploading}" @click="toCheck()" v-if="select.depart.has_verify">送审</button>
    </li>
    <li class="button right">
      <div v-if="select.depart.has_release || select.depart.has_verify" :class="{autoPost: true, autoPostOn: autoPost.on}" @click="switchAutoPost()">
        <img :src="autoPost.on?autoPost.icons.on:autoPost.icons.off" alt="checker">
        <span>{{`传完自动${select.depart.has_release?'提交':'送审'}`}}</span>
      </div>
      <button @click="reportToEdit()" v-if="global.has_quick_edit_role">to快编</button>
    </li>
  </footer>
  <withTopic :from="3" ref="withTopic" @getTopic="fetchTopic" />
  <withInterview :from="3" ref="withInterview" @getInterview="fetchInterview" />
  <withClue ref="withClue" @getClue="fetchClue" />
  <checkers ref="checkers" />
  <div class="showSave" v-show="autoSave.show">
    <img src="@assets/img/common/right.svg" alt="right">
    <span>已保存至草稿箱</span>
  </div>
  </div>
  <pushBox ref="pushBox" />
  <div class="lock" v-if="lock.show">
    <p class="msg">{{`该稿件已被锁定，正在被${lock.locker}编辑`}}</p>
  </div>
  <successTip ref="successTip" />
  <audioCompose ref="audioCompose" />
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import { apis } from "@common/config";
import common from "@common/common";
import headline from "@components/headline";
import mediaCenter from "@components/mediaCenter";
import withTopic from "@components/withTopic";
import withInterview from "@components/withInterview";
import withClue from "@components/withClue";
import dc from "@common/dc";
import checkers from "@components/checkers";
import empty from "@components/empty";
import pushBox from "@components/pushBox";
import successTip from "@components/successTip";
import audioCompose from "@components/audioCompose";

export default {
  components: {
    VueUeditorWrap,
    headline,
    mediaCenter,
    withTopic,
    withInterview,
    withClue,
    checkers,
    empty,
    pushBox,
    successTip,
    audioCompose
  },
  data() {
    return {
      hasCover: false,
      cover: '',
      isXnew: this.$store.state.isXnew,
      headLines: {
        title: "",
        showLink: false,
        filter: false
      },
      isNew: true,
      isPush: false,
      isDraft: false,
      saveAfterCopyclues: false,
      global: {},
      speed: 330,
      mediaData: null,
      listData: null,
      selectedType: {},
      withTopic: {},
      withInterview: {},
      withClues: [],
      defaultImg: require("@assets/img/common/default.png"),
      icons: {
        downward: require("@assets/img/common/xiala.svg"),
        upward: require("@assets/img/common/upward.svg"),
        upRed: require("@assets/img/common/up-red.svg"),
        downRed: require("@assets/img/common/down-red.svg")
      },
      tag: "",
      tmpId: "",
      uploading: false,
      showClue: false,
      normalConfig: {
        autoHeightEnabled: true,
        initialFrameHeight: 640,
        initialFrameWidth: "100%",
        enableAutoSave: false,
        autoFloatEnabled: true,
        imageScaleEnabled: false,
        saveInterval: 24 * 60 * 60 * 1000,
        topOffset: 70,
        autotypeset: {
          textAlign: "left"
        },
        toolbars: [
          [
            "undo",
            "redo",
            "|",
            "fontsize",
            "|",
            "blockquote",
            "horizontal",
            "|",
            "removeformat",
            "formatmatch",
            "|",
            "link",
            "unlink",
            "bold",
            "italic",
            "underline",
            "forecolor",
            "backcolor",
            "|",
            "indent",
            "justifyleft",
            "justifycenter",
            "justifyright",
            "justifyjustify",
            "|",
            "rowspacingtop",
            "rowspacingbottom",
            "lineheight",
            "fontborder"
            // "|",
            // "imagenone",
            // "imageleft",
            // "imageright",
            // "imagecenter"
          ]
        ]
      },
      tvConfig: {
        autoHeightEnabled: true,
        initialFrameHeight: 640,
        initialFrameWidth: "100%",
        enableAutoSave: false,
        enableContextMenu: false,
        autoFloatEnabled: true,
        saveInterval: 24 * 60 * 60 * 1000,
        topOffset: 70,
        pasteplain: true,
        autotypeset: {
          textAlign: "left"
        },
        toolbars: []
      },
      select: {
        depart: {
          text: null,
          on: false,
          id: null,
          has_release: false,
          has_verify: false
        },
        platform: {
          // text: null,
          on: false
          // id: null
        }
      },
      normalContent: "",
      tvText: {
        body: "",
        lead: "",
        after: ""
      },
      radioText: "",
      // tvContent: '<p>[正文]<br/><br/><br/>[导语]<br/><br/><br/>[编后]</p>',
      // originTVContent: '<p>[正文]<br/><br/><br/>[导语]<br/><br/><br/>[编后]</p>',
      tvInstance: null,
      normalInstance: null,
      bodyText: "", // 正文纯文字
      headText: "", // 导语纯文字
      bodyDurantion: 0, // 正文时长
      headDurantion: 0, // 导语时长
      errors: {
        list: [],
        fix: false,
        width: "",
        dexpand: false,
        showToggle: false,
        scrollTop: 0
      },
      autoSave: {
        show: false,
        time: 30 * 1000,
        interval: null
      },
      lock: {
        locker: "",
        show: false,
        time: 15 * 1000,
        interval: null
      },
      pageId: "",
      watchCount: 0,
      pushList: [],
      canInsert: false,
      showNoToast: false, // 用于控制post后的toast显示，多次使用需要重置
      autoPost: {
        icons: {
          on: require("@assets/img/common/autoCheckerOn.svg"),
          off: require("@assets/img/common/autoChecker.svg")
        },
        on: false
      },
      pushIds: "cancel",
      normalWindow: {},
      audioComposeConfig: {
        title: "",
        article: "",
        target: "",
        app_id: "",
        app_secret: "",
        host: "",
        page_type: "",
        page_id: 0
      },
      transformingImgs: {
        loading: false,
        msg: ""
      }
    };
  },
  created() {
    // 判断是新建、推送还是编辑
    const type = this.$route.query.t;
    this.isNew = !this.$route.query.d;
    this.pushId = this.$route.query.push;
    let title = "";

    if (this.isNew) {
      title = `新建${this.$_syscfg.report}`;
    } else {
      title = `编辑${this.$_syscfg.report}`;
    }

    if (this.pushId) {
      title = `推送${this.$_syscfg.report}`;
    }

    this.headLines.title = title;
    this.selectedType.id = type;
    this.canInsert = this.selectedType.id != 1 && this.selectedType.id != 2;
    // 初始化数据。是否正在抓取图片(黏贴文稿中的图片)
    this.grabingImg = false;
  },
  watch: {
    // tvContent: function(n, o) {
    //   this.watchContentCount()
    //   this.watchContent(n)
    // },
    // tvText: {
    //   handler: function(n, o) {
    //     console.log('watchtvtext', n)
    //     this.watchContentCount()
    //     this.watchTV()
    //   },
    //   deep: true
    // },
    radioText: {
      handler: function (n, o) {
        console.log("watchradio", n);
        this.watchContentCount();
        this.watchRadio();
      },
      deep: true
    },
    tvText: {
      handler: function (n, o) {
        console.log("watchtvtext", n);
        this.watchContentCount();
        this.watchTV();
      },
      deep: true
    },
    normalContent: function (n, o) {
      this.watchContentCount();
    }
  },
  methods: {
    setNewCover(e) {
      this.cover = e;
      this.hasCover = true;
    },
    localUpload() {
      let httpUpBtn = document.querySelector('#httpUpBtn');
      httpUpBtn.click()
      this.$refs.mediaCenter.localUploadCover = true;
    },
    maskMaterial() {
      this.$refs.mediaCenter.showMaterialListBox1('myMaterial', false).then(res => {
        this.cover = res;
        this.hasCover = true;
      })
    },
    async saveAndApprove() {
      // 修改并通过
      if (this.uploading) return;

      this.uploading = true;
      const id = this.$route.query.d || this.tmpId;
      const postDataFetch = await this.postData("modify");
      let verifyFetch = null;

      if (postDataFetch) {
        const info = {
          report_id: id,
          status: 0
        };

        verifyFetch = await common.myFetch(apis.Rpt_handle_report, info);

        if (verifyFetch) {
          window.onbeforeunload = null;
          console.log(window.onbeforeunload, window.close()); // 这个consolelog不要删，没有它后面的close不会执行，奇怪的现象待调研
          window.close();
        } else {
          this.uploading = false;
        }
      } else {
        this.uploading = false;
      }

      // this.postData('modify').then((r) => {
      //   if (r) {
      //     let info = {
      //       report_id: id,
      //       status: 0
      //     }
      //
      //     console.log(6666, pageWindow)
      //     pageWindow.close()
      //
      //     common.myFetch(apis.Rpt_handle_report, info)
      //     .then((res) => {
      //       if (res) {
      //         this.$toast(res)
      //         pageWindow.onbeforeunload = null
      //         setTimeout(() => {
      //           console.log(22223333, pageWindow)
      //           pageWindow.close()
      //         }, 0)
      //       }
      //     })
      //   }
      // })
    },
    uploadComplete() {
      if (!this.autoPost.on) {
        this.postData("auto");

        return;
      }

      if (this.select.depart.has_release) {
        console.log("执行发布");
        this.releaseAndJump("release");
      } else if (this.select.depart.has_verify) {
        console.log("执行送审");
        this.toCheck();
      }
    },
    async switchAutoPost() {
      if (!this.autoPost.on) {
        // 切换为选中
        const allNeeds = this.checkNeeds();
        if (!allNeeds) return;

        this.showNoToast = true;
        let id = await this.postData("save");

        this.pushIds = await this.$refs.pushBox.open(id);
        if (this.pushIds === "cancel") return;
      } else {
        this.pushIds = "cancel";
      }

      console.log("pushids", this.pushIds);

      this.$set(this.autoPost, "on", !this.autoPost.on);
    },
    checkNeeds() {
      // 检查必填项
      let allNeeds = true;
      let msgs = [];
      let msg = "";

      if (!this.global.report_title) {
        msgs.push("标题");
        allNeeds = false;
      }

      if (!this.select.depart.id) {
        msgs.push("部门");
        allNeeds = false;
      }

      if (!allNeeds) {
        msg = `${msgs.join("、")}不能为空`;
        this.$toast(msg);
      }

      return allNeeds;
    },
    asyncText(key, type = "tv", e) {
      // 模拟vmodel，监听电视稿输入元素
      const text = e.target.innerText;
      if (type == "radio") {
        this.radioText = text;
      } else {
        this.tvText[key] = text;
      }
    },
    watchContentCount() {
      // 监听编辑器内容变化加入弹窗提醒
      console.log("contentchanges", this.watchCount);
      if (this.watchCount > 2) {
        window.onbeforeunload = function (e) {
          const event = e || window.event;
          return (event.returnValue = true);
        };
      }

      this.watchCount += 1;
      this.setAutosave();
    },
    reportToEdit() {
      // 报道to快遍
      const info = {
        id: this.$route.query.d || this.tmpId
      };

      common.myFetch(apis.Rpt_toEdit, info).then(r => {
        if (r) {
          this.$toast(r);
        }
      });
    },
    getUploading(s) {
      this.uploading = s;

      if (this.uploading) {
        window.onbeforeunload = function (e) {
          const event = e || window.event;
          return (event.returnValue = true);
        };
      }
    },
    handleAutoSave() {
      try {
        this.postData("auto").then(r => {
          if (r) {
            this.showSaveTip();
          }
        });
      } catch (e) {
        console.log(e);
      }
    },
    handleLock() {
      const info = {
        report_id: this.$route.query.d || this.tmpId
      };

      common
        .myFetch(apis.Rpt_lock, { data: info, hideLoading: this.grabingImg })
        .then(r => {
          if (r) {
            console.log("lock", r);
          }
        });
    },
    handleUnlock() {
      const id = this.pageId || this.tmpId;
      if (!id) return;

      const info = {
        report_id: id
      };

      common.myFetch(apis.Rpt_unlock, info).then(r => {
        if (r) {
          console.log("unlock", r);
        }
      });
    },
    showSaveTip() {
      // 显示自动保存提示
      this.autoSave.show = true;

      setTimeout(() => {
        this.autoSave.show = false;
      }, 2000);
    },
    cleanMark(content) {
      // 清除mark
      content = content.replace("<mark>", "").replace("</mark>", "");

      return content;
    },
    replaceWord(content, word, start, end) {
      //  将需要标注的词用标签标注，并替换到文本中
      content = this.cleanMark(content);
      content = `${content.substring(
        0,
        start
      )}<mark>${word}</mark>${content.substring(end)}`;

      return content;
    },
    locateWord(w) {
      // 定位文字
      if (this.selectedType.id == 1) {
        this.tvContent = this.replaceWord(
          this.tvContent,
          w.Error,
          w.Pos,
          w.Pos + w.WordsLen
        );
      } else {
        this.normalContent = this.replaceWord(
          this.normalContent,
          w.Error,
          w.Pos,
          w.Pos + w.WordsLen
        );
      }

      const normalDom = this.normalInstance.document;
      // const tvDom = this.tvInstance.document
      const dom = this.selectedType.id == 1 ? tvDom : normalDom;
      const range = new window.UE.dom.Range(dom);
      // const errors = document.querySelector('.errors')

      setTimeout(() => {
        const node = dom.getElementsByTagName("mark")[0];
        const wrapper =
          this.selectedType.id == 1
            ? document.getElementById("tvWrapper")
            : document.getElementById("normalWrapper");
        const endPos = wrapper.getBoundingClientRect().top + 80;

        range.selectNode(node).select();
        range.scrollToView(window, endPos);
      }, 200);
    },
    checkWords() {
      // 检测错别字
      this.errors.list = [];
      this.errors.dexpand = false;
      this.errors.showToggle = false;
      let content = "";
      if (this.selectedType.id == 1) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);

        content = `<p>[正文]</p><p>${body}</p><p>[导语]</p><p>${lead}</p><p>[编后]</p><p>${after}</p>`;

        content = common.replaceN2Br(content);
      } else if (this.selectedType.id == 0) {
        content = this.normalContent;
      } else if (this.selectedType.id == 2) {
        content = `<p>${this.radioText}</p>`;

        content = common.replaceN2Br(content);
      }

      const info = {
        content: content
      };

      common.myFetch(apis.File_checkWord, info).then(res => {
        if (res) {
          // this.errors.list = res

          if (res.length === 0) {
            this.$toast("没有检测到错别字");
            return;
          }
          const type = this.selectedType.id - 0;
          const typoData = {
            type: type,
            content: content,
            errors: res
          };

          this.$typo(typoData).then(r => {
            if (!r) return;

            if (type === 1) {
              this.$refs.tvTextBody.innerText = r.body;
              this.$refs.tvTextLead.innerText = r.lead;
              this.$refs.tvTextAfter.innerText = r.after;
              this.tvText = {
                body: r.body,
                lead: r.lead,
                after: r.after
              };
            } else if (type === 0) {
              this.normalContent = r.content;
            } else if (type === 2) {
              this.$refs.radioTextBody.innerText = r.content;
              this.radioText = r.content;
            }
          });
        }
      });
    },
    setSpeed() {
      // 设置语速并计算时长
      let speed = this.speed;
      if (this.speed > 500) {
        speed = 500;
      }
      if (this.speed < 0) {
        speed = 0;
      }
      this.speed = speed;

      this.calculateText();
    },
    watchTV() {
      this.watchTVcontent();

      this.calculateText();
    },
    watchRadio() {
      this.calculateRadio();
    },
    watchTVcontent() {
      // 检测电视稿内容格式
      const extraBodys = this.tvText.body.indexOf("[正文]") > -1;
      const extraLeads = this.tvText.lead.indexOf("[导语]") > -1;
      const extraAfters = this.tvText.after.indexOf("[编后]") > -1;
      let msg = "请保证电视稿中有且只有一个";
      const msgList = [];

      if (extraBodys) {
        msgList.push("[正文]");
      }

      if (extraLeads) {
        msgList.push("[导语]");
      }

      if (extraAfters) {
        msgList.push("[编后]");
      }

      if (msgList.length > 0) {
        msg += msgList.join("、");

        this.$toast(msg, 1000);
      }
    },
    calculateRadio() {
      // 计算时长, 广播
      const gap = 60 / this.speed;
      this.bodyText = common.replacePunctuations(this.radioText);

      this.bodyDurantion = gap * this.bodyText.length;
    },
    calculateText() {
      // 计算时长, 电视稿
      const gap = 60 / this.speed;
      this.headText = common.replacePunctuations(this.tvText.lead);
      this.bodyText = common.replacePunctuations(this.tvText.body);

      this.bodyDurantion = gap * this.bodyText.length;
      this.headDurantion = gap * this.headText.length;
    },
    normalReady(i) {
      this.normalInstance = i;
      this.normalWindow = this.normalInstance.window;
      // 先触发 beforepaste。再触发 contentChange
      i.addListener("beforepaste", (eventName, { html }) =>
        this.handleGrabWXimg(html)
      );
      this.init(); // 由于使用v-show电视稿时也会执行这里
    },
    /**
     * 在mediaCenter中删除多媒体，在编辑器中也要删除对应的文件
     * 如果是audio 要通过idstring删除
     * type :0 图片，1 视频 ，2 音频
     */
    deleteMedia({ src, idstring, type }) {
      let tag = type == 0 ? "img" : type == 1 ? "video" : "iframe";
      let allMedia = this.normalWindow.document.querySelectorAll(tag);
      let ms = [...allMedia].filter(m => {
        if (tag == "img" || tag == "video") {
          return m.src === src;
        } else {
          return m.src.indexOf(idstring) >= 0;
        }
      });
      console.log("ms", ms);
      ms.forEach(m => {
        m.parentNode.removeChild(m);
        m = null;
      });
    },
    /**
     *  subject_id 先获取id。绑定上传的图片 。路由来，要么从已有的临时的来，如果都没有 就去拿临时的id
     *  最后再做格式化。包括自动保存。保存草稿、发布
     *  这里只需要黏贴成功即可
     */
    async handleGrabWXimg(html) {
      let fragment = document.createElement("div");
      fragment.innerHTML = html;
      // 过滤掉本身 就已经是 smg的图片了。
      let imgs = [...fragment.getElementsByTagName("img")].filter(
        img => img.src.indexOf("media.smgtech.net") < 0
      );
      if (!imgs || !imgs.length) return;
      // 抓取图片时间较长，通过该字段 控制其他定时接口不显示loading
      this.grabingImg = true;
      let ueditorDocument = this.normalWindow.document;
      // 打开loading 说明正在转换。
      this.transformingImgs = {
        loading: true,
        msg: `检测到${imgs.length}张新图片，正在转换...`
      };
      // 如果向编辑器添加内容，禁止
      ueditorDocument.body.contentEditable = false;

      let imgUrls = JSON.stringify(imgs.map(img => img.src));
      // todo 让imgs的src为空
      imgs.forEach(img => (img.src = ""));

      // 拿转换地址。
      let data = {
        imgs: imgUrls,
        subject_id:
          this.$route.query.d || (await this.$refs.mediaCenter.getTempId()),
        subject_type: 1
      };

      const postUrls = await common.myFetch(apis.grabwximg, {
        data,
        hideLoading: true
      });
      // 让编辑器 可编辑
      ueditorDocument.body.contentEditable = true;
      let allImgs = ueditorDocument.querySelectorAll("img");
      console.log("allImgs", allImgs);
      console.log("postUrls", postUrls);
      // 然后找到对应的img, 原始路径 original_url，替换replace_url
      let failTransformImgs = [];
      for (let img of allImgs) {
        let item = postUrls.find(e => {
          return e.original_url === img.src;
        });
        if (item) {
          // 如果转换成功，替换src
          if (item.replace_url) {
            console.log("找到要替换的 图片item", item);
            img.src = item.replace_url;
          }
          // 失败，就count,并删除图片节点
          else {
            failTransformImgs.push(img);
          }
        }
      }
      this.transformingImgs = {
        loading: false,
        msg: ``
      };
      this.grabingImg = false;
      console.log("failTransformImgs 转换失败的张数 ", failTransformImgs);
      // todo 如果有失败的，找到parentNode 删掉
      if (failTransformImgs.length) {
        // 提示 有几张图片转换失败
        this.$toast(`有${failTransformImgs.length}张图片转换失败,请稍后重试~`);
        failTransformImgs.forEach(img => {
          img.parentNode.removeChild(img);
          img = null;
        });
      }
      // 重新setContent。原本v-model改变的是不同步的
      this.normalInstance.setContent(ueditorDocument.body.innerHTML);
    },
    foldClues() {
      this.showClue = !this.showClue;
      this.$refs.mediaCenter.folding = !this.showClue;
    },
    addHrefId(id) {
      // 获取到id后添加到url上
      if (window.location.href.indexOf("d=") < 0) {
        if (window.location.href.indexOf("?") < 0) {
          // window.location.href += `?d=${id}`;
          this.$router.push(window.location.pathname + `?d=${id}`)
        } else {
          // window.location.href += `&d=${id}`;
          const i = window.location.href.indexOf("?")
          const t = window.location.href.substring(i)
          this.$router.push(window.location.pathname + t + `&d=${id}`)
        }
      }
    },
    getTempId() {
      // 获取报道／线索 临时id
      const info = {
        submit_act: "upload"
      };

      return common.myFetch(apis.saveReport, info).then(r => {
        if (r) {
          const id = r.report_id;
          this.tmpId = id;
          this.addHrefId(id);

          return id;
        }
      });
    },
    async compositeAudio() {
      // 合成音频
      const title = this.global.report_title;
      const tvContent = `[正文]${this.tvText.body}[导语]${this.tvText.lead
        }[编后]${this.tvText.after}`;
      let content = this.normalContent;

      if (this.selectedType.id == 1) {
        content = tvContent;
      } else if (this.selectedType.id == 2) {
        content = this.radioText;
      }

      if (!title) {
        this.$toast("请填写标题");
        return;
      }

      // if (!content) {
      //   this.$toast('请填写正文')
      //   return
      // }

      let id = this.$route.query.d || this.tmpId;
      if (!id) {
        id = await this.getTempId();
      }

      this.audioComposeConfig.title = this.global.report_title;
      this.audioComposeConfig.article = content;
      this.audioComposeConfig.page_type = "report";
      this.audioComposeConfig.page_id = id;
      this.audioComposeConfig.makeup_audio_version = this.global.makeup_audio_version;

      this.$refs.audioCompose.open(this.audioComposeConfig);

      // if (!this.speed) {
      //   this.$toast('请设置语速')
      //   return
      // }

      // const info = {
      //   title: this.global.report_title,
      //   content: content,
      //   objid: id,
      //   objtype: 'report',
      //   spd: this.speed
      // }

      // common.myFetch(apis.File_composite, info)
      // .then(r => {
      //   if (r) {
      //     // this.$toast(r)
      //     this.$success({
      //       title: '合成任务正在生成',
      //       detail: '稍后请在多媒体库的音频列表中查看新合成的'
      //     }).then((res) => {
      //       this.$refs.mediaCenter.getFileAssets(true)
      //       this.$refs.mediaCenter.navSwitch(2)
      //     })
      //   }
      // })
    },
    getUploadConfig(r) {
      // 获取上传参数
      this.audioComposeConfig.target = r.pickuptext_path;
      this.audioComposeConfig.app_id = common.hex2str(r.pickuptext_id);
      this.audioComposeConfig.app_secret = common.hex2str(r.pickuptext_secret);
      this.audioComposeConfig.host = common.hex2str(r.pickuptext_host);
      console.log("接收上传参数", r, this.audioComposeConfig);
    },
    async toCheck() {
      if (this.uploading) return;

      this.uploading = true;
      // let id = this.$route.query.d || this.tmpId
      this.showNoToast = true;
      const id = await this.postData("save");

      if (!id) {
        this.uploading = false;
        return;
      }

      const pushIds =
        this.pushIds === "cancel"
          ? await this.$refs.pushBox.open(id)
          : this.pushIds;
      if (pushIds === "cancel") {
        this.uploading = false;
        return;
      }

      const info = {
        report_id: id,
        push_id: pushIds
      };

      common.myFetch(apis.checker_add, info).then(r => {
        if (r) {
          // this.$toast(r)

          window.onbeforeunload = null;
          console.log(window.close());
          window.close();
        } else {
          this.uploading = false;
        }
      });
    },
    getInsert(dom) {
      // 接收插入稿件数据
      if (this.selectedType.id == 1) {
        // this.tvContent = this.tvContent + dom
        if (dom.type === "img") {
          this.tvInstance.execCommand(
            "inserthtml",
            `<img style="max-width: 80%; height: auto;" src="${dom.url}" />`
          );
        } else if (dom.type === "video") {
          this.tvInstance.execCommand(
            "inserthtml",
            `<p></p><p><video style="max-width: 80%; height: auto;" controls src="${dom.url
            }" poster="${dom.cover
            }" controlsList="nodownload" /><br /></p><p></p>`
          );
        } else if (dom.type === "audio") {
          this.tvInstance.execCommand(
            "inserthtml",
            `<p></p><iframe frameborder="0" width="100%" height="80" src="${window.location.origin
            }/static/xnsaudio/audio.html?is=${dom.idstring
            }" allowFullScreen="false"></iframe><br /><p></p>`
          );
        }
      } else {
        if (dom.type === "img") {
          this.normalInstance.execCommand(
            "inserthtml",
            `<img style="max-width: 80%; height: auto;" src="${dom.url}" />`
          );
        } else if (dom.type === "video") {
          this.normalInstance.execCommand(
            "inserthtml",
            `<p></p><p><video style="max-width: 80%; height: auto;" controls src="${dom.url
            }" poster="${dom.cover
            }" controlsList="nodownload">video</video><br /></p><p></p>`
          );
        } else if (dom.type === "audio") {
          this.normalInstance.execCommand(
            "inserthtml",
            `<p></p><iframe frameborder="0" width="100%" height="80" src="${window.location.origin
            }/static/xnsaudio/audio.html?is=${dom.idstring
            }" allowFullScreen="false"></iframe><br /><p></p>`
          );
        }
      }
    },
    getPid(id) {
      // 获取临时id
      this.tmpId = id;
    },
    generateTag() {
      // 根据内容生成标签
      const tvContent = `[正文]${this.tvText.body}[导语]${this.tvText.lead
        }[编后]${this.tvText.after}`;
      let content = this.normalContent;

      if (this.selectedType.id == 1) {
        content = tvContent;
      } else if (this.selectedType.id == 2) {
        content = this.radioText;
      }

      const contentData = common.escapeEscapes(common.cleanHtmlTags(content));

      const info = {
        content: contentData,
        topnum: 5
      };

      common.myFetch(apis.split_words, info).then(r => {
        if (r) {
          const arrObj = {};
          r.forEach(i => {
            arrObj[i] = "a";
          });

          this.global.tags.forEach(j => {
            if (arrObj.hasOwnProperty(j)) {
              arrObj[j] = "d";
            }
          });

          const res = [];

          for (const k in arrObj) {
            if (arrObj[k] === "a") {
              res.push(k);
            }
          }

          console.log("123212", arrObj, res);
          this.global.tags = this.global.tags.concat(res);
        }
      });
    },
    addTag() {
      if (!this.tag) return;

      if (this.tag.length > 8) {
        this.$toast("标签字数不能超过8个");
        return;
      }

      const allTags = this.global.tags || [];
      if (allTags.filter(i => i === this.tag).length > 0) {
        this.$toast("请勿重复添加");
        this.tag = "";
        return;
      }

      this.global.tags.push(this.tag);
      this.tag = "";
    },
    deleteTag(i) {
      this.global.tags.forEach((j, ji) => {
        if (i === j) {
          this.global.tags.splice(ji, 1);
        }
      });
    },
    deleteItv(i) {
      // 删除关联采访
      this.withInterview = {};
    },
    deleteTpc(t) {
      // 删除关联选题
      this.withTopic = {};
    },
    deleteClue(clue) {
      // 删除关联线索
      this.global.materials.forEach((i, d) => {
        if (clue.material_id === i.material_id) {
          this.global.materials.splice(d, 1);
        }
      });
    },
    addClue() {
      const materials = this.global.materials;

      this.$refs.withClue.open(materials);
    },
    openWith(key) {
      this.$refs[key].open();
    },
    fetchTopic(t) {
      // 获取关联选题
      this.withTopic = t;
    },
    fetchInterview(i) {
      // 获取关联采访
      this.withInterview = i;
    },
    fetchClue(res) {
      // 获取关联线索
      const cluesBefore = this.global.materials.map(i => i.material_id);
      const clues = [];
      res.forEach(i => {
        if (cluesBefore.indexOf(i.material_id) < 0) {
          clues.push(i);
        }
      });

      this.withClues = res;
      this.$set(this.global, "materials", this.withClues);
      if (res.length === 0) return;

      const title = (clues[0] || {}).title || "";
      let content = "";
      let body = "";
      let lead = "";
      let after = "";
      let reporter = "";
      let video = "";

      clues.forEach(i => {
        if (i.type == 0) {
          content += i.content;
          body += i.content;
        } else {
          const contentBody = common.getBody(i.content); // 当被关联的电视稿内容格式有问题时（包括了无内容），将其全部内容放到正文中
          if (!contentBody) {
            content += i.content;
            body += i.content;
          } else {
            content += i.content;
            body += common.getBody(i.content);
            lead += common.getLead(i.content);
            after += common.getAfter(i.content);
            reporter += common.getReporterText(i.content);
            video += common.getVideoText(i.content);
          }
        }
      });

      // 关联线索时，如何处理策划、采访、标签？（待处理）

      if (clues.length === 0) return; //如果没有新选择的线索，则不操作

      const contentData = {
        content: content,
        body: body,
        lead: lead,
        after: after,
        reporter: reporter,
        video: video
      };

      this.combinePage(title, contentData, false);

      const mids = clues.map(i => i.material_id).join(",");
      if (!mids) return;
      this.copyClueFiles(mids);
    },
    selectUp(t, x, open) {
      if (!open) return;

      if (x) {
        this.select[t].text = x.title;
        this.select[t].id = x.id;
        this.select[t].has_release = !!x.has_release;
        this.select[t].has_verify = !!x.has_verify;
        this.pushList = x.pushto_platform;
      } else {
        window.document.addEventListener("click", this.hideDep);
      }

      this.select[t].on = !this.select[t].on;
    },
    hideDep() {
      this.select["depart"].on = false;

      window.document.removeEventListener("click", this.hideDep);
    },
    // openPlat() {
    //   this.select.platform.on = !this.select.platform.on
    //
    //   window.document.addEventListener('click', this.hidePlat)
    // },
    // hidePlat() {
    //   this.select.platform.on = false
    //   window.document.removeEventListener('click', this.hidePlat)
    // },
    // selectPlatform(p, l) {
    //   this.$set(p, 'selected', !p.selected)
    //   // this.select.platform.on = false
    //   this.$nextTick(() => {
    //     if (p.id == '2' && p.selected) {
    //       l.forEach((i) => {
    //         if (i.id == '1') {
    //           this.$set(i, 'selected', true)
    //         }
    //       })
    //     }
    //   })
    // },
    goClue(id) {
      common.jump(`/clueDetail?d=${id}`, true);
    },
    getData() {
      // 获取数据
      let info = {};

      if (!this.isNew) {
        info["report_id"] = this.$route.query.d;
        this.pageId = this.$route.query.d;
      }

      return common.myFetch(apis.creatReportGlobal, info).then(res => {
        if (res) {
          this.global = res.detail;
          if(this.global.cover != '' && this.global.cover != undefined && this.global.cover != null && this.global.cover != 'undefined'){
            this.cover = this.global.cover;
          }else{
            this.cover = '';
          }
          
          if(this.cover){
            this.hasCover = true;
          }else{
            this.hasCover = false;
          }
          this.speed = this.global.content_speed || 330;
          // this.has_edit_video_role
          this.$set(
            this.global,
            "tags",
            this.global.tags.map(i => i.title || i)
          );
          this.autoSelected();
          this.getDC();

          if (this.global.iview_id != 0) {
            this.fetchInterview({
              id: this.global.iview_id,
              title: this.global.iview_title
            });
          }
          if (this.global.topic_id != 0) {
            this.fetchTopic({
              id: this.global.topic_id,
              title: this.global.topic_title
            });
          }

          this.mediaData = {
            img: this.global.img_list.map(i => {
              i.name = i.title;
              return i;
            }),
            audio: this.global.sound_list.map(i => {
              i.name = i.title;
              return i;
            }),
            video: this.global.video_list.map(i => {
              i.name = i.title;
              return i;
            }),
            file: this.global.file_list.map(i => {
              i.name = i.title;
              return i;
            })
          };

          return res.detail;
        }
      });
    },
    getDC() {
      // 获取环境中关联的采访和线索
      const interview = dc.getItv() || {};

      this.withInterview = this.withInterview.id
        ? this.withInterview
        : interview;
    },
    async combinePage(title, content) {
      // 将线索内容插入到稿件中
      const type = this.selectedType.id;
      this.global.report_title = this.global.report_title || title;

      if (type == 1) {
        this.insertTVContent(content.body, "[正文]");
        this.insertTVContent(content.lead, "[导语]");
        this.insertTVContent(content.after, "[编后]");

        if (!content.body && !content.lead && !content.after) {
          let contentBody = common.replaceBr2N(content.content);

          this.insertTVContent(contentBody, "[正文]");
        }
      } else {
        this.normalContent =
          this.normalContent + common.replaceN2Br(content.content);
      }
    },
    insertTVContent(content, spliter) {
      // 将指定部分内容插入到电视稿中, 推送过来直接放置，关联则新增
      content = common.replaceTags(content); // 将内容中的[正文/导语/编后]转为【正文/导语/编后】
      content = common.cleanHtml(content);

      let tv = this.global.content;
      tv = common.replaceBr2N(tv);
      const body = common.getBody(tv) || this.tvText.body;
      const lead = common.getLead(tv) || this.tvText.lead;
      const after = common.getAfter(tv) || this.tvText.after;

      if (spliter == "[正文]") {
        this.tvText.body = body + content;
        this.$refs.tvTextBody.innerText = body + content;
      } else if (spliter == "[导语]") {
        this.tvText.lead = lead + content;
        this.$refs.tvTextLead.innerText = lead + content;
      } else if (spliter == "[编后]") {
        this.tvText.after = after + content;
        this.$refs.tvTextAfter.innerText = after + content;
      }
    },
    async copyClueFiles(mid) {
      // 将线索文件复制到报道上
      let id = this.$route.query.d || this.tmpId;
      if (!id) {
        id = await this.postData("save");
      }

      const create_from = this.$route.query.push ? 1 : 0;
      const info = {
        mid: mid,
        report_id: id,
        create_from: create_from
      };
      this.uploading = true;

      common
        .myFetch(apis.File_copy, { data: info, hideLoading: true })
        .then(r => {
          if (r) {
            if (r.report_id) {
              this.addHrefId(r.report_id);
            }

            this.mediaData = {
              img: r.img_list.map(i => {
                i.name = i.title;
                return i;
              }),
              audio: r.sound_list.map(i => {
                i.name = i.title;
                return i;
              }),
              video: r.video_list.map(i => {
                i.name = i.title;
                return i;
              }),
              file: r.file_list.map(i => {
                i.name = i.title;
                return i;
              })
            };
            this.uploading = false;
            // 复制素材后进行保存
            if (this.saveAfterCopyclues) {
              this.showNoToast = true;
              this.saveAndJump("save");
            }
          }
        });
    },
    autoSelected() {
      // 加载时默认选中部门和平台
      this.global.depart_arr.forEach(i => {
        if (i.selected) {
          this.select.depart.text = i.title;
          this.select.depart.id = i.id;
          this.select.depart.has_release = !!i.has_release;
          this.select.depart.has_verify = !!i.has_verify;
          this.pushList = i.pushto_platform;
        }
      });

      if (!this.isNew) {
        this.selectedType.id = this.$route.query.t || this.global.type;
        this.canInsert = this.selectedType.id != 1 && this.selectedType.id != 2;
      }

      // 根据数据渲染内容
      if (this.selectedType.id == 0) {
        this.normalContent = common.replaceN2Br(this.global.content);

        this.$nextTick(() => {
          // 将新媒体稿编辑器内容中的xnsaudio替换为自定义
          common.formatXNSAudios(this.normalWindow.document);

          this.$nextTick(() => {
            setTimeout(() => {
              const _hiddenNormal = document.querySelector("._hiddenNormal");
              const _hiddenNormalHeight = window
                .getComputedStyle(_hiddenNormal, null)
                .getPropertyValue("height");

              if (
                parseInt(this.normalInstance.iframe.parentNode.style.height) >=
                parseInt(_hiddenNormalHeight)
              )
                return;

              this.normalInstance.iframe.parentNode.style.height = _hiddenNormalHeight;
            }, 1000);
          });
        });
      } else if (this.selectedType.id == 1) {
        let tv = this.global.content;
        tv = common.replaceBr2N(tv);
        let body = common.getBody(tv);
        let lead = common.getLead(tv);
        let after = common.getAfter(tv);
        body = common.replaceTags(body);
        lead = common.replaceTags(lead);
        after = common.replaceTags(after);
        this.$refs.tvTextBody.innerText = body;
        this.$refs.tvTextLead.innerText = lead;
        this.$refs.tvTextAfter.innerText = after;
        this.tvText = {
          body: body,
          lead: lead,
          after: after
        };

        setTimeout(() => {
          this.bodyFocus();
        }, 0);
      } else if (this.selectedType.id == 2) {
        let radio = this.global.content;
        radio = common.replaceBr2N(radio);
        radio = common.replaceTags(radio);
        this.$refs.radioTextBody.innerText = radio;
        this.radioText = radio;
      }

      this.$nextTick(() => {
        common.handlePageMediaCenterPosition();
      });
    },
    bodyFocus() {
      // 将焦点定位到正文输入框中并且位于文字之后
      const bodyDom = this.$refs.tvTextBody;
      bodyDom.focus();

      // if (window.getSelection) {
      //   const selection = window.getSelection()
      //   const range = document.createRange()
      //   const n = this.tvText.body.length
      //
      //   range.setStart(bodyDom.firstChild, n)
      //   range.selectNode(bodyDom)
      //   selection.removeAllRanges()
      //   selection.addRange(range)
      // }
    },
    async saveAndJump(status) {
      if (this.uploading) return;

      this.uploading = true;
      this.postData(status).then(r => {
        if (r) {
          if (status === "save") {
            this.uploading = false;
            return;
          }

          window.onbeforeunload = null;
          console.log(window.close());
          window.close();
        } else {
          this.uploading = false;
        }
      });
    },
    async releaseAndJump(status) {
      if (this.uploading) return;

      this.uploading = true;

      // let id = this.$route.query.d || this.tmpId

      const id = await this.postData(status);

      if (id) {
        this.publish(id).then(r => {
          if (r) {
            window.onbeforeunload = null;

            const info = {
              msg: r.msg_one,
              tip: r.msg_two || "页面即将关闭"
            };

            this.$refs.successTip.open(info);
          } else {
            this.uploading = false;
          }
        });
      } else {
        this.uploading = false;
      }
    },
    async publish(id) {
      const pushIds =
        this.pushIds === "cancel"
          ? await this.$refs.pushBox.open(id)
          : this.pushIds;
      if (pushIds === "cancel") {
        this.uploading = false;
        return;
      }

      const info = {
        report_id: id,
        push_id: pushIds
      };

      return common.myFetch(apis.Rpt_release, info).then(res => {
        return res;
      });
    },
    async postData(status) {
      // 提交数据
      let content = "";
      // let isEmpty = false
      if (this.selectedType.id == 1) {
        const body = common.replaceTags(this.tvText.body);
        const lead = common.replaceTags(this.tvText.lead);
        const after = common.replaceTags(this.tvText.after);

        content = `[正文]${body}[导语]${lead}[编后]${after}`;
      } else if (this.selectedType.id == 0) {
        content = this.normalContent
          .replace(/\<mark\>/g, "")
          .replace(/\<\/mark\>/g, "");
      } else if (this.selectedType.id == 2) {
        content = common.replaceTags(this.radioText);
      }

      // if (this.uploading && status !== 'save' && status !== 'auto') return  //上传时禁止提交（保存草稿和自动保存例外）

      const allTags = this.global.tags.concat(this.generateTags).join(",");
      const id = this.$route.query.d || this.tmpId;
      const data = {
        title: this.global.report_title,
        depart_id: this.select.depart.id || "",
        depart_title: this.select.depart.text || "",
        content: content,
        type: this.selectedType.id,
        submit_act: status,
        // create_from: create_from,
        st_id: this.withTopic.id || "",
        iview_id: this.withInterview.id || "",
        tags: allTags,
        mid: this.global.materials.map(j => j.material_id).join(","),
        // push_id: this.select.platform.id,
        // push_id: push_id,
        report_id: id,
        content_speed: this.speed,
        reporters: this.global.reporters || "",
        cameras: this.global.cameras || "",
        cover: this.cover
      };

      return common
        .myFetch(apis.saveReport, {
          data: data,
          hideLoading: this.showNoToast || this.grabingImg
        })
        .then(r => {
          if (r) {
            if (status != "sub" && status != "auto" && status != "release") {
              if (!this.showNoToast) {
                this.$toast("操作成功");
              }

              this.showNoToast = false; // 如果showNoToast被设置true，则调用一次之后重置为false
            }

            this.addHrefId(r.report_id);

            return r.report_id;
          }

          return r;
        });
    },
    getFold(status) {
      this.showClue = !status;
    },
    checkPageContent() {
      // 检测稿件内容是否做过编辑
      let change = false;

      if (this.selectedType.id == 1) {
        change =
          !!this.tvText.body || !!this.tvText.lead || !!this.tvText.after;
      } else if (this.selectedType.id == 0) {
        change = !!this.normalContent;
      } else if (this.selectedType.id == 2) {
        change = !!this.radioText;
      }

      return change;
    },
    setAutosave() {
      const contentChanged = this.checkPageContent();
      if (this.isDraft && contentChanged) {
        this.autoSave.interval =
          this.autoSave.interval ||
          setInterval(() => {
            this.handleAutoSave();
          }, this.autoSave.time);
      } else {
        if (this.autoSave.interval) {
          clearInterval(this.autoSave.interval);
          this.autoSave.interval = null;
        }
      }
    },
    init() {
      // 初始化方法
      this.getData().then(r => {
        if (r) {
          this.isDraft = r.status == 0;
          if (this.isNew) {
            // 只在新建的情况下开启关联线索后保存
            this.saveAfterCopyclues = r.is_delete == 0;
          }
          this.setAutosave();

          if (!this.isNew) {
            if (!r.is_lock) {
              this.lock.interval =
                this.lock.interval ||
                setInterval(() => {
                  this.handleLock();
                }, this.lock.time);
            } else {
              this.lock.locker = r.lock_user_name;
              this.lock.show = true;
            }
          }
        }
      });
    }
  },
  mounted() {
    this.defaultImg = this.$_syscfg.default_img
    // this.getData().then(r => {
    //   if (r) {
    //     this.isDraft = r.status == 0
    //     if (this.isNew) {
    //       // 只在新建的情况下开启关联线索后保存
    //       this.saveAfterCopyclues = r.is_delete == 0
    //     }
    //     this.setAutosave()
    //
    //     if (!this.isNew) {
    //       if (!r.is_lock) {
    //         this.lock.interval = this.lock.interval || setInterval(() => {
    //           this.handleLock()
    //         }, this.lock.time)
    //       } else {
    //         this.lock.locker = r.lock_user_name
    //         this.lock.show = true
    //       }
    //     }
    //   }
    // })
  },
  destroyed() {
    window.onbeforeunload = null;
    if (this.autoSave.interval) {
      clearInterval(this.autoSave.interval);
      this.autoSave.interval = null;
    }

    if (this.lock.interval) {
      clearInterval(this.lock.interval);
      this.handleUnlock();
    }
  }
};
</script>

<style src="@assets/css/mediaDetails/mediaCreat.less" lang="less" scoped>
</style>
<style lang="less" scoped>
#normalWrapper {
  position: relative;
}
.loadingWithContent-wrapper {
  position: absolute;
  background: rgba(white, 0.9);
  top: 0;
  right: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
}
.loadingWithContent {
  position: fixed;
  top: 50%;
  left: calc(80px + (100vw - 523px) / 2);
  transform: translate(-50%, -50%);
  overflow: visible;
  text-align: center;
  padding: 10px;
  border-radius: 10px;
  background-color: rgba(65, 180, 140, 0.9);
  border: 1px solid #41b48c;
  img {
    width: 80px;
    height: 80px;
  }
  .title {
    color: white;
    white-space: nowrap;
  }
}
.loadingwrapper {
  .mask {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background-color: rgba(teal, 0.3);
  }
}
</style>
